import {
  CHART_CALCULATION,
  CHART_METRIC,
} from '@/entities/chart/model/constants';

export type ChartMetricPolicy = {
  comboSecondary: {
    calculation: CHART_CALCULATION;
    metric: CHART_METRIC;
  };
  fallbackMetric: CHART_METRIC;
  labelOverrides?: Partial<Record<CHART_METRIC, string>>;
  metrics: readonly CHART_METRIC[];
};

export const CHART_METRIC_POLICY: ChartMetricPolicy = {
  metrics: [
    CHART_METRIC.FEEDBACK,
    CHART_METRIC.TOTAL_ENGAGEMENT,
    CHART_METRIC.ENGAGEMENT_RATE,
    CHART_METRIC.IMPRESSION,
    CHART_METRIC.UNIQUE_ACCOUNT,
    CHART_METRIC.UNIQUE_CONTACT,
    CHART_METRIC.ACCOUNT_REVENUE_IMPACT,
    CHART_METRIC.CONTACT_REVENUE_IMPACT,
    CHART_METRIC.RATING_SCORE,
    CHART_METRIC.NPS_SCORE,
    CHART_METRIC.CSAT_SCORE,
    CHART_METRIC.CES_SCORE,
  ],
  fallbackMetric: CHART_METRIC.FEEDBACK,
  comboSecondary: {
    metric: CHART_METRIC.RATING_SCORE,
    calculation: CHART_CALCULATION.AVERAGE,
  },
};
